module.exports = {"title":"Asocio"};